import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const lemmy = defineConnector({
  identifier: "lemmy",
  name: "Lemmy",
  tagLine: "Federated link aggregator and forum",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.instanceUrl}/api/v3/user/login`,
        method: "POST",
        jsonBody: {
          username_or_email: app.config.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["jwt"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Enter your Lemmy instance details",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          placeholder: "https://lemmy.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "The base URL of your Lemmy instance (e.g., https://lemmy.ml).",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v3/site`,
  },
});
